import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { LoginFormComponent } from '../core/login-form/login-form.component';
import { HomeComponent } from '../home/home.component';
import { NovaSenhaComponent } from '../core/nova-senha/nova-senha.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginFormComponent,
    data: {
      title: 'Assistência Médica Moura',
    }
  },
  {
    path: 'nova-senha',
    component: NovaSenhaComponent
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [RouterModule]
})
export class SegurancaRoutingModule { }
